import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "errorEmoji",
  "use": "errorEmoji-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"errorEmoji\">\n    <path d=\"M29 0h30v88H29z\" />\n    <path d=\"M18 6h52v76H18z\" />\n    <path d=\"M12 12h64v64H12z\" />\n    <path d=\"M6 18h76v52H6z\" />\n    <path d=\"M0 30h88v28H0z\" />\n    <path fill=\"currentColor\" d=\"M41 59h6v6h-6zM47 59h6v6h-6zM53 65h6v6h-6zM29 65h6v6h-6zM35 59h6v6h-6zM18 47h6v6h-6zM64 47h6v6h-6zM24 41h12v6H24zM52 41h12v6H52z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol